import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useAppContext } from '../../../hooks/AppContext';
import { Modal } from 'carbon-components-react';
import Step1 from '../../Molecules/Steps/Step1';
import Step2 from '../../Molecules/Steps/Step2';
import Step3 from '../../Molecules/Steps/Step3';
import Step4 from '../../Molecules/Steps/Step4';
import Step5 from '../../Molecules/Steps/Step5';
import { useHistory } from 'react-router-dom';
import {
  getQuestion,
  getSelectedAnswer,
  getSubQuestionId,
  getSubmittedTrueValues,
} from '../../../utility';
import { prop, isEmpty, propOr } from 'ramda';
import Result from '../../Molecules/Result/Result';
import { ErrorFilled20, Restart20 } from '@carbon/icons-react';
import Thanks from '../../Molecules/Thanks/Thanks';
import * as URX_FORM from '../../../constant/urx-form';
import { swapCountryAndLanguage } from '../../../utility/swapCountryAndLanguage';
import { IBMLocale } from 'src/common/locale/mapValidLocale';
import { initUrxForm } from 'src/common/hooks/widgets/urxForm';
import { useEnv } from 'src/common/hooks/widgets/useEnv';
import messages from '../../../locales/messages';
import { FormattedMessage } from 'react-intl';
import { segmentTracking } from '../../../lib/tracker';
import Cookies from 'js-cookie';
import Selection from '../../Molecules/Selection/Selection';
import BusinessPartner from 'src/common/components/BusinessPartner/BusinessPartner';
import { FormModal } from 'src/common/utils/FormModal';
import { useLang } from 'src/common/hooks/widgets/useLang';
import countryList from '../../../constant/currencies.json';

export interface selectionProps {
  state: string;
  answer: string;
  id: string;
}

type PopUpModalProps = {
  langCode: string;
  bpName: string;
  logo: string;
  companyId: string;
  tileValue: string;
  setTileValue: React.Dispatch<React.SetStateAction<string>>;
  countryToTest: string;
  test: boolean;
};

export const Assessment = ({
  langCode,
  bpName,
  logo,
  companyId,
  tileValue,
  test,
  countryToTest,
}: PopUpModalProps) => {
  const { appState, appAction } = useAppContext();
  const scope3Option = prop('scope3')(appState);
  const [environment] = useEnv();
  const [step, setStep] = useState(1);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [modal, setModal] = useState(true);
  const [formComplete, setFormComplete] = useState(false);
  const [scopeOption, setScopeOption] = useState(
    scope3Option ? scope3Option : '',
  );
  const localeCode = swapCountryAndLanguage(langCode as IBMLocale);
  const [subQueState, setSubQueState] = useState(false);
  const questionData = getQuestion(appState, prop('currentQuestion')(appState));
  const {
    scopeEmissionsQueId,
    complianceQueId,
    insightsQueId,
    esgReportingQueId,
  } = getSubQuestionId(appState);
  const submittedValue = getSubmittedTrueValues(appState);
  const price = prop('price')(appState);
  const q3b = submittedValue[4];
  const q3c = submittedValue[5];
  const required = propOr(false, 'required')(questionData);
  const currentQuestion = prop('currentQuestion')(appState);
  const mandatoryQueId = required ? currentQuestion : '';
  const queArray = [q3b, q3c];
  const history = useHistory();
  const intl = useIntl();
  const multipleQueExist =
    queArray.length &&
    queArray.every((value) => {
      return submittedValue.includes(value);
    });

  type ansProps = {
    id: string;
    state: string;
    answer: string;
  };

  const submitted = prop('submitted')(appState);
  const getAns: ansProps[] = getSelectedAnswer(appState);
  const formattedAns = getAns.map((data) => ({
    ...data,
    answer: data.answer.split(' ')[0].split('-')[0],
  }));

  const answerObj = formattedAns.filter((item) => item.id === currentQuestion);
  const insight =
    getAns
      .filter((item) => item.id === insightsQueId)
      .map((item) => item.answer.split('Cookie-')[1])
      .toString() === 'Yes';

  const emptyAns =
    currentQuestion === 'Q2' &&
    answerObj.length &&
    isEmpty(answerObj[0].answer);

  type valueProps = {
    id: string;
    answer: string;
    state: string;
  };

  const getValue = (id: string, ans: valueProps[]) => {
    return ans
      .filter((item: valueProps) => item.id === id)
      .map((item: valueProps) => item.answer)
      .toString();
  };

  const Q7 = getValue(esgReportingQueId, formattedAns);
  const [, setCurrency] = useState('');
  const [, setCountry] = useState('');

  const [lang] = useLang(
    countryList,
    test,
    countryToTest,
    setCurrency,
    setCountry,
    localeCode,
  );

  useEffect(() => {
    appAction({
      type: 'start',
      answerId: '',
      answerValue: false,
    });
  }, []);

  window.urxEnvironment = environment;
  window.onUrxFormSubmitSuccess = () => {
    setFormComplete(!formComplete);
    setDrawerOpen(false);
    setModal(false);
  };

  const handleReset = () => {
    segmentTracking('CTA Clicked', {
      pageTitle: 'Envizi Price Estimator',
      object: 'Envizi page',
      resultValue: 'CTA clicked',
      CTA: 'Start Over',
      location: 'Assessment',
      action: '',
      field: '',
    });
    appAction({
      type: 'reset',
      answerId: '',
      answerValue: false,
    });
    appAction({
      type: 'start',
      answerId: '',
      answerValue: false,
    });
    setStep(1);
    Cookies.remove('urxdcq');
    setSubQueState(false);
    setScopeOption('');
  };

  const handleCloseModal = () => {
    setModal(false);
    segmentTracking('CTA Clicked', {
      pageTitle: 'Envizi Price Estimator',
      object: 'Envizi page',
      resultValue: 'CTA clicked',
      CTA: 'Close icon',
      location: 'Assessment',
      action: '',
      field: '',
    });
    history.push('/');
  };

  const handleContact = () => {
    setModal(false);
    setDrawerOpen(true);
    initUrxForm(
      environment,
      URX_FORM.INSTANCE_ID,
      URX_FORM.FORM_ID,
      localeCode as IBMLocale,
      companyId,
    );
  };

  const getFinalResult = () => {
    const index = 4;
    for (let i = formattedAns.length; i > index; i--) {
      formattedAns[i] = formattedAns[i - 1];
    }
    formattedAns[index] = {
      state: 'Scope 3 emissions',
      answer: scope3Option,
      id: 'Q8',
    };
    return formattedAns;
  };

  useEffect(() => {
    if (!drawerOpen && !modal && !formComplete) {
      setModal(true);
    }
  }, [drawerOpen]);

  const finalResult = scope3Option ? getFinalResult() : formattedAns;
  const handleSegmentTracking = (cta: string, location: string) => {
    segmentTracking('CTA Clicked', {
      pageTitle: 'Envizi Price Estimator',
      object: 'Envizi page',
      resultValue: 'CTA clicked',
      CTA: cta,
      location: location,
      action: '',
      field: '',
    });
  };

  return (
    <div className="bx--grid">
      <Modal
        open={modal}
        primaryButtonDisabled={
          (required && !subQueState
            ? !(mandatoryQueId in submitted) ||
              (currentQuestion === 'Q2' && emptyAns)
            : subQueState &&
              currentQuestion === 'Q3' &&
              !(scopeEmissionsQueId in submitted && !isEmpty(scope3Option))
            ? true
            : currentQuestion === 'Q5' &&
              !(mandatoryQueId in submitted && insightsQueId in submitted)
            ? true
            : currentQuestion === 'Q7'
            ? !(mandatoryQueId in submitted)
            : false) || (step === 5 && isEmpty(price) ? true : false)
        }
        onRequestClose={handleCloseModal}
        onSecondarySubmit={() => {
          if (step === 1) {
            setModal(false);
            history.push('/');
            handleSegmentTracking('Close', 'Return to Estimator');
          } else if (step === 2) {
            setStep((step) => step - 1);
            appAction({ type: 'previous' });
            handleSegmentTracking('Back', 'Assessment');
          } else if (step === 5) {
            appAction({ type: 'last' });
            setStep((step) => step - 1);
            handleSegmentTracking('Back', 'Assessment');
          } else {
            if (scopeOption === 'Yes' && step > 2) {
              handleSegmentTracking('Back', 'Assessment');
              if (currentQuestion === 'Q3') {
                appAction({ type: 'previous', queId: 'Q3' });
                setStep((step) => step - 1);
              } else if (currentQuestion === 'Q5') {
                appAction({ type: 'previous', queId: 'Q4' });
              } else if (currentQuestion === 'Q7') {
                appAction({ type: 'previous', queId: 'Q6' });
                setStep((step) => step - 1);
              }
            } else {
              handleSegmentTracking('Back', 'Assessment');
              if (
                (scopeOption === 'No' || isEmpty(scopeOption)) &&
                currentQuestion === 'Q7'
              ) {
                appAction({ type: 'previous', queId: 'Q4' });
                setStep((step) => step - 1);
              } else {
                appAction({ type: 'previous' });
                setStep((step) => step - 1);
              }
            }
          }
        }}
        passiveModal={formComplete ? true : false}
        primaryButtonText={
          step === 4
            ? intl.formatMessage(messages.showResult_btn)
            : step === 5
            ? intl.formatMessage(messages.contact_btn)
            : intl.formatMessage(messages.next_btn)
        }
        secondaryButtonText={
          step > 1
            ? intl.formatMessage(messages.back_btn)
            : intl.formatMessage(messages.close)
        }
        preventCloseOnClickOutside={true}
        onRequestSubmit={() => {
          if (currentQuestion === 'Q7') {
            handleSegmentTracking('Next', 'Result Screen');
            if (!isEmpty(price) && step === 5) {
              handleSegmentTracking('Contact us for a quote', 'Result Screen');
              handleContact();
            } else {
              setStep((step) => step + 1);
            }
          } else {
            handleSegmentTracking('Next', 'Assessment');
            if (step <= 4) {
              if (step > 2 && scopeOption === 'Yes') {
                appAction({ type: 'next', queId: 'Q4' });
                if (currentQuestion === 'Q5') {
                  appAction({ type: 'next', queId: 'Q6' });
                  setStep((step) => step + 1);
                }
              } else {
                if (
                  currentQuestion === 'Q3' &&
                  (scopeOption === 'No' || isEmpty(scopeOption))
                ) {
                  appAction({ type: 'next', queId: 'Q7' });
                  setStep((step) => step + 1);
                } else {
                  appAction({ type: 'next' });
                  setStep((step) => step + 1);
                }
              }
            }
          }
        }}
        size="lg"
      >
        <div className="bx--row">
          <div className="bx--col-lg-16 bx--col-md-16 bx--col-sm-16">
            {bpName ? (
              <BusinessPartner bpName={bpName} logo={logo} urxForm={true} />
            ) : null}
          </div>
        </div>
        <div className="bx--row">
          <div className="bx--col-lg-9 bx--col-md-16 bx--col-sm-16">
            {step > 0 && step < 5 && currentQuestion !== 'Q5' && (
              <p className="ibm-mb-1 step">Question {step} of 4</p>
            )}
            {currentQuestion === 'Q1' && step > 0 && (
              <Step1
                isOpen={currentQuestion === 'Q1'}
                question={questionData}
              />
            )}
            {currentQuestion === 'Q2' && (
              <Step2
                isOpen={currentQuestion === 'Q2'}
                question={questionData}
              />
            )}
            {currentQuestion === 'Q3' && (
              <Step3
                isOpen={currentQuestion === 'Q3'}
                question={questionData}
                subQueState={subQueState}
                setSubQueState={setSubQueState}
                scopeOption={scopeOption}
                setScopeOption={setScopeOption}
              />
            )}
            {currentQuestion === 'Q5' && (
              <Step4
                isOpen={currentQuestion === 'Q5' && scopeOption === 'Yes'}
                question={questionData}
              />
            )}
            {currentQuestion === 'Q7' && step === 4 && (
              <Step5
                isOpen={currentQuestion === 'Q7'}
                question={questionData}
              />
            )}
            {step === 5 && !formComplete && (
              <Result
                langCode={langCode}
                isOpen={true}
                answers={getAns}
                insight={insight}
                tileValue={tileValue}
                test={test}
                countryToTest={countryToTest}
              />
            )}
          </div>
          <div className="bx--col-lg-1" />
          {step > 0 && !isEmpty(getAns) && (
            <div className="bx--col-lg-6 bx--col-md-16 bx--col-sm-16">
              <div className="results">
                <div className="reset-item" onClick={handleReset}>
                  <span>
                    <FormattedMessage {...messages.start_over} />
                  </span>
                  <Restart20 className="restart-icon" />
                </div>
                <div className="selection">
                  <FormattedMessage {...messages.your_selection} />
                </div>
                <ul>
                  {!isEmpty(getAns) &&
                    finalResult.map((item: selectionProps, index: number) =>
                      index === 5 &&
                      !isEmpty(getValue(complianceQueId, formattedAns)) &&
                      scope3Option === 'Yes' ? (
                        <Selection
                          id={complianceQueId}
                          answer={item.answer}
                          result={formattedAns}
                          key={item.id}
                          state=""
                        />
                      ) : index === 6 &&
                        !isEmpty(getValue(insightsQueId, formattedAns)) &&
                        scope3Option === 'Yes' ? (
                        <Selection
                          id={insightsQueId}
                          answer={item.answer}
                          result={formattedAns}
                          key={item.id}
                          state=""
                        />
                      ) : index === 4 && scope3Option === 'Yes' ? (
                        <li className="selection-item" key={item.id}>
                          <div className="margin">
                            <span className="bold_text">
                              <FormattedMessage {...messages.scope3_title} />
                            </span>
                          </div>
                        </li>
                      ) : index === 6 && Q7 && !multipleQueExist ? (
                        <Selection
                          answer={item.answer}
                          result={formattedAns}
                          state={item.state}
                          key={item.id}
                        />
                      ) : index === 4 && scope3Option === 'No' ? (
                        <li className="selection-item" key={item.id}>
                          <div className="margin">
                            <span className="selection-state">
                              <FormattedMessage {...messages.scope3_title} />:
                            </span>
                            <span className="bold_text answer">
                              {scope3Option}
                            </span>
                            {scope3Option === 'No' && (
                              <ErrorFilled20
                                className="icon-style"
                                fill="#8d8d8d"
                              />
                            )}
                          </div>
                        </li>
                      ) : (
                        <Selection
                          answer={item.answer}
                          result={formattedAns}
                          state={item.state}
                          key={item.id}
                        />
                      ),
                    )}
                </ul>
              </div>
            </div>
          )}
        </div>
      </Modal>
      {step === 5 && formComplete && (
        <Thanks
          lowerPrice={price.lowerPrice}
          higherPrice={price.higherPrice}
          insight={insight}
          bpName={bpName}
        />
      )}
      <FormModal
        pageTitle="Envizi Price Estimator"
        object="Envizi Price Estimator Page"
        productTitle={'Envizi Price Estimator'}
        pageUrl={''}
        location={'Assessment'}
        bpName={bpName}
        logo={logo}
        drawerOpen={drawerOpen}
        setDrawerOpen={setDrawerOpen}
        formId={URX_FORM.FORM_ID}
        lang={lang}
      ></FormModal>
    </div>
  );
};
